
  import { defineComponent } from 'vue';
  import { abreWhatsApp } from '@/uteis/contato';
  import LogoLimaTec from './LogoLimaTec.vue';

  export default defineComponent({
    name: 'WhatsappFlutuante',
    components: {
      LogoLimaTec
    },
    props: {
      Texto: {
        type: String,
        default: ""
      },
      TextoWhatsApp: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        aberto: false,
        mensagem: "",
        hora: ""
      };
    },
    methods: {
        // chamado de fora (barra mobile) via ref
        abrir() {
            if (!this.aberto) {
                this.alternar();
            }
        },
        alternar() {
            this.aberto = !this.aberto;
            if (this.aberto) {
                const agora = new Date();
                this.hora = `${String(agora.getHours()).padStart(2, '0')}:${String(agora.getMinutes()).padStart(2, '0')}`;
                this.$nextTick(() => {
                    (this.$refs.campoMensagem as HTMLInputElement | undefined)?.focus();
                });
            }
        },
        enviar() {
            const texto = this.mensagem.trim();
            if (!texto) {
                return;
            }
            abreWhatsApp(texto, 'Chat');
            this.mensagem = "";
            this.aberto = false;
        },
        enviarPronta(texto: string) {
            abreWhatsApp(texto, 'Chat');
            this.aberto = false;
        }
    }
  });
